import React, { FC, useRef } from 'react'
import { Drawer as BaseDrawer, ANCHOR, SIZE } from 'baseui/drawer'
import { DrawerBody, CloseContainer, DrawerContainer } from './Drawer.style'
import { useTranslation } from 'react-i18next'

interface DrawerProps {
    isOpen: boolean
    content: React.ReactNode
    onClose: () => void
    animate?: boolean
    showBackdrop?: boolean
    anchor?: typeof ANCHOR
    size?: typeof SIZE
}

const Drawer: FC<DrawerProps> = ({
    isOpen,
    content,
    onClose,
    animate = true,
    showBackdrop = true,
    anchor = ANCHOR.bottom,
    size = SIZE.auto
}) => {
    const { t } = useTranslation()
    const touchStartRef = useRef(0)
    const touchMoveRef = useRef(0)

    const handleTouchStart = (e: React.TouchEvent) => {
        touchStartRef.current = e.touches[0].clientY
    }

    const handleTouchMove = (e: React.TouchEvent) => {
        touchMoveRef.current = e.touches[0].clientY
    }

    const handleTouchEnd = () => {
        const swipeDistance = touchMoveRef.current - touchStartRef.current
        if (swipeDistance > 100) {
            onClose()
        }
    }

    return (
        <BaseDrawer
            animate={animate}
            showBackdrop={showBackdrop}
            onClose={onClose}
            isOpen={isOpen}
            autoFocus={false}
            size={size as string}
            anchor={anchor as string}
            overrides={{
                DrawerBody: {
                    component: ({ children, ...props }) => (
                        <DrawerBody
                            {...props}
                            onTouchStart={handleTouchStart}
                            onTouchMove={handleTouchMove}
                            onTouchEnd={handleTouchEnd}
                        >
                            {children}
                        </DrawerBody>
                    )
                },
                DrawerContainer,
                Close: {
                    component: () => (
                        <CloseContainer onClick={onClose}>
                            <i className="wemolo-cross" aria-label={t('common.close')} />
                        </CloseContainer>
                    )
                }
            }}
        >
            {content}
        </BaseDrawer>
    )
}

export default Drawer
